export default __webpack_public_path__ + "static/media/00.ee5a905d.png";